const INTERNAL_ORIGIN = "https://golf-booking.invalid"

type SignedInRole = "golfer" | "staff" | "manager"

export function defaultDemoPath(
  userId: string,
  role: SignedInRole
): "/" | "/staff" | "/staff/pro-shop" {
  if (role === "golfer") {
    return "/"
  }

  return userId === "user-demo-staff" ? "/staff/pro-shop" : "/staff"
}

export function postLoginPath(
  next: string | undefined,
  userId: string,
  role: SignedInRole
): string {
  if (!next) {
    return defaultDemoPath(userId, role)
  }

  const isStaffDestination = next === "/staff" || next.startsWith("/staff/")
  const isGolferDestination =
    next === "/my-bookings" ||
    next.startsWith("/my-bookings/") ||
    next === "/membership"

  if (isStaffDestination && role === "golfer") {
    return defaultDemoPath(userId, role)
  }

  if (isGolferDestination && role !== "golfer") {
    return defaultDemoPath(userId, role)
  }

  return next
}

export function safeInternalPath(value: unknown): string | undefined {
  if (
    typeof value !== "string" ||
    !value.startsWith("/") ||
    value.startsWith("//") ||
    value.includes("\\")
  ) {
    return undefined
  }

  let decoded = value

  try {
    for (let pass = 0; pass < 2; pass += 1) {
      decoded = decodeURIComponent(decoded)
    }
  } catch {
    return undefined
  }

  if (decoded.startsWith("//") || decoded.includes("\\")) {
    return undefined
  }

  const base = new URL(INTERNAL_ORIGIN)
  const resolved = new URL(value, base)

  if (resolved.origin !== base.origin) {
    return undefined
  }

  return `${resolved.pathname}${resolved.search}${resolved.hash}`
}
